/**
 * Name sent as `browser` in the sign-in payload on web.
 *
 * Sign-in always reported "Mobile App", so the activity log could not tell a
 * browser or desktop login from the Android app. Order matters below: Edge and
 * Electron user agents also contain "Chrome", and Chrome's contains "Safari".
 */
export function getClientName(): string {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (/Electron\//.test(ua)) return 'ZenBasket POS Desktop';
  if (/Edg\//.test(ua)) return 'Microsoft Edge';
  if (/OPR\//.test(ua)) return 'Opera';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Chrome\//.test(ua)) return 'Google Chrome';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Web Browser';
}
